import { StyleSheet, Platform } from 'react-native';
import { Colors } from '@qnpm/q-theme';

const { scenes:{ baseColor } } = Colors;

export default StyleSheet.create({
    queryContent: {
        marginHorizontal: 12,
        marginTop: 16,
        backgroundColor: '#FEFEFE',
        borderRadius: 8,
        paddingBottom: 20
    },
    inputItem: {
        marginHorizontal: 16,
        paddingVertical: 18,
        flexDirection: 'row',
        alignItems: 'center',
        borderBottomWidth: StyleSheet.hairlineWidth,
        borderBottomColor: '#EEE'
    },
    countrySelectWrapper: {
        height: 18,
        width: 60,
        borderRightWidth: StyleSheet.hairlineWidth,
        borderRightColor: '#eee',
        justifyContent: 'center'
    },
    countrySelectCont: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    countrySelectText: {
        fontSize: 16,
        color: baseColor.text1,
        ...Platform.select({
            android: {
                marginTop: -2
            }
        })
    },
    countrySelectIcon: {
        marginLeft: 5,
        fontSize: 12
    },
    textInput: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center'
    },
    inputLabel: {
        flex: 1,
        paddingLeft: 16,
        height: 18,
        paddingVertical: 0,
        color: '#000',
        fontSize: 14
    },
    inputTitle: {
        width: 60
    },
    buttonWrapper: {
        borderColor: '#00BCD4',
        borderRadius: 4,
        borderWidth: 1,
        paddingVertical: 5,
        paddingHorizontal: 6,
        height: 28,
        justifyContent: 'center',
        alignItems: 'center',
        width: 85
    },
    buttonText: {
        color: '#00BCD4',
        fontSize: 13
    },
    buttonDisableView: {
        borderColor: '#E0E0E0'
    },
    buttonDisableText: {
        color: '#E0E0E0'
    },
    confirm: {
        marginHorizontal: 16,
        marginTop: 16,
        borderRadius: 4,
        height: 44,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#00BCD4'
    },
    confirmDisableView: {
        backgroundColor: 'rgba(0,188,212,0.40)'
    },
    confirmText: {
        color: '#FFF',
        fontSize: 16
    }
});
